<template>
  <div class="contact container">
    <div class="row">
      <div class="col-12 flex contact__inner">
        <div class="contact__inquiries">
          <strong>Inquiries</strong><br>
          <a class="contact__email" :href="`mailto:${contact.email}`">{{ contact.email }}</a>
        </div>
        <div class="contact__address">
          <strong>Thank You For Clapping</strong><br>
          {{ contact.street }}<br>
          {{ contact.postal_code }} {{ contact.city }}<br>
          {{ contact.country }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store'

export default {
  name: 'contact',
  data () {
    return {
      contact: store.contact
    }
  }
}
</script>

<style lang="sass" scoped>

@import "../assets/sass/utilities/variables"
@import "../assets/sass/utilities/mixins"

.contact
  position: fixed
  right: 20px
  bottom: 20px
  left: 0
  height: 100%
  display: flex
  align-items: flex-end
  font-weight: 500
  +small
    left: 0
    bottom: 50px
    right: 50px
  @media (min-width: 1400px)
    position: static
    height: 100vh

.row
  width: 100%

.contact__inner
  display: flex
  flex-direction: column
  justify-content: flex-end
  font-size: 1rem
  color: $black
  width: 100%
  +small
    width: 50%
  @media (min-width: 1400px)
    padding-bottom: 60px
    margin-top: auto

.contact__inquiries
  margin-top: auto
  margin-bottom: 2rem
  h2
    font-size: 1rem
    margin: 0

.contact__email
  margin-left: auto
  margin-right: auto

</style>



// WEBPACK FOOTER //
// Contact.vue?2ff3f326